// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"qQ-z","carouselContainer":"rQ-z"};